<header class="p-[1rem] border-b flex justify-between items-center text-white rounded-t-xl !w-full" 
  style="background: linear-gradient(to right, #ff8b4d 0, #c373a3 57%, #905eed 100%)">
  <div class="font-bold text-2xl flex items-center gap-3 w-full">
    <dsr-icon color="white" name="speech-feedback" size="32px" class="!rounded-full" aria-hidden="true"></dsr-icon>
    <div class="flex-1 text-start w-full">
      <span class="dsr-typescale-title-small">
        {{'CHATBOT_TITLE' | translate}}
        <span class="dsr-typescale-title-small">
          *
        </span>
      </span>
    </div>
    <button type="button" class="flex items-center cursor-pointer" (click)="toggleChatDisplay()"
      aria-label="Close chat assistant">
      <dsr-icon color="white" name="cancel" size="12px" aria-hidden="true"></dsr-icon>
    </button>
  </div>
</header>
